import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  ca: {
    app_name: "HOSYS INVOICE AI",
    nav: {
      dashboard: "Tauler",
      clients: "Clients",
      quotes: "Pressupostos",
      invoices: "Factures",
      received: "Factures rebudes",
      mailbox: "Bústia",
      products: "Mercaderies",
      suppliers: "Proveïdors",
      tax_books: "Llibres fiscals",
      pricing: "Plans",
      security: "Seguretat",
      settings: "Configuració",
      logout: "Tancar sessió",
      activity: "Activitat",
    },
    landing: {
      tag: "Plataforma SaaS de facturació amb IA de veu",
      headline: "Factura amb la veu. Cobra amb estil.",
      sub: "Crea pressupostos i factures professionals dictant-los. La nostra IA entén el català i el castellà, redacta els conceptes i ho deixa tot llest per signar.",
      cta_primary: "Comença gratis",
      cta_secondary: "Veure demo",
      feature_voice_title: "Agent IA de veu",
      feature_voice_desc: 'Digues "Fes un pressupost per Restaurant Demo SL de 7.600 € més IVA" i tindràs el document creat.',
      feature_pdf_title: "PDFs A4 enterprise",
      feature_pdf_desc: "Logotip corporatiu, IBAN, QR de pagament i taules elegants en cada document.",
      feature_multi_title: "Multi-empresa",
      feature_multi_desc: "Gestiona diverses empreses, equips i numeracions des d'un sol compte.",
      feature_2fa_title: "Seguretat empresarial",
      feature_2fa_desc: "JWT, 2FA TOTP, logs d'activitat, xifrat i protecció anti-força bruta.",
      stats: { docs: "documents generats", uptime: "uptime", langs: "idiomes IA" },
      demo_label: "Demo",
      demo_quote_prefix: "Fes un pressupost per",
      demo_quote_client: "Restaurant Demo SL",
      demo_quote_amount: "de 7.600 € més IVA per",
      demo_quote_suffix: "desenvolupament web i plataforma CRM.",
      demo_lines: "3 línies generades",
      demo_iva: "IVA 21%",
      demo_json_desc_1: "Desenvolupament lloc web corporatiu",
      demo_json_desc_2: "Configuració CRM i Business Analytics",
      demo_json_desc_3: "Integració WebApp PWA i mobile-first",
      features_section_tag: "Característiques",
      features_section_title: "Tot el que necessites per facturar amb estil.",
      cta_section_badge: "Llest en 30 segons",
      cta_section_title: "Comença a facturar amb veu, avui.",
      cta_section_sub: "Sense targeta de crèdit. Sense compromís. Cancel·la quan vulguis.",
      cta_section_btn: "Crea el teu compte gratis",
      footer_made: "Fet amb ❤ a Reus",
    },
    auth: {
      login: "Inicia sessió",
      register: "Crea el teu compte",
      email: "Email",
      password: "Contrasenya",
      full_name: "Nom complet",
      company_name: "Nom de l'empresa",
      submit_login: "Entrar",
      submit_register: "Crear compte",
      no_account: "No tens compte?",
      have_account: "Ja tens compte?",
      totp_label: "Codi 2FA (6 dígits)",
      forgot_password: "Has oblidat la contrasenya?",
      lang: "Idioma",
    },
    dashboard: {
      title: "Tauler",
      welcome: "Bon dia",
      revenue_month: "Facturació del mes",
      pending: "Pendent de cobrar",
      paid: "Cobrat",
      overdue: "Impagat",
      clients: "Clients",
      invoices: "Factures",
      quotes: "Pressupostos",
      monthly_revenue: "Evolució mensual",
      upcoming: "Venciments propers",
      recent_activity: "Activitat recent",
      no_data: "Encara no hi ha dades. Crea el primer document!",
      voice_cta: "Dicta un document",
    },
    clients: {
      title: "Clients",
      new: "Nou client",
      search: "Cerca per nom, NIF o email...",
      name: "Nom",
      nif: "NIF/CIF",
      email: "Email",
      phone: "Telèfon",
      address: "Adreça",
      city: "Població",
      postal_code: "Codi postal",
      country: "País",
      notes: "Notes internes",
      tags: "Etiquetes",
      save: "Desar",
      cancel: "Cancel·lar",
      delete: "Eliminar",
      edit: "Editar",
      empty: "Cap client encara. Comença afegint el primer.",
      delete_confirm: "Segur que vols eliminar aquest client?",
      history: "Historial",
    },
    quotes: {
      title: "Pressupostos",
      new: "Nou pressupost",
      number: "Núm.",
      client: "Client",
      date: "Data",
      total: "Total",
      status: "Estat",
      actions: "Accions",
      duplicate: "Duplicar",
      convert: "Convertir a factura",
      pdf: "PDF",
      empty: "Cap pressupost encara.",
      valid_until: "Vàlid fins",
    },
    invoices: {
      title: "Factures",
      new: "Nova factura",
      number: "Núm.",
      client: "Client",
      date: "Data",
      due_date: "Venciment",
      total: "Total",
      status: "Estat",
      empty: "Cap factura encara.",
      mark_paid: "Marcar com cobrada",
      record_payment: "Registrar pagament",
      amount: "Import",
      method: "Mètode",
      partial_paid: "Cobrat parcialment",
    },
    editor: {
      new_quote: "Nou pressupost",
      new_invoice: "Nova factura",
      edit_quote: "Editar pressupost",
      edit_invoice: "Editar factura",
      client: "Client",
      select_client: "Selecciona un client",
      add_item: "Afegir línia",
      description: "Descripció",
      quantity: "Quantitat",
      unit_price: "Preu unitari",
      vat: "IVA %",
      irpf: "IRPF %",
      discount: "Desc %",
      subtotal: "Subtotal",
      tax: "Impostos",
      total: "Total",
      notes: "Notes",
      observations: "Observacions",
      save: "Desar",
      saving: "Desant...",
      save_send: "Desar i enviar",
      improve: "Millorar amb IA",
      delete: "Eliminar línia",
      back: "Tornar",
      status: "Estat",
      due_date: "Venciment",
      date: "Data",
      kind: "Tipus",
    },
    voice: {
      title: "Agent IA de veu",
      sub: "Prem el botó i descriu el document. La IA crearà el pressupost o factura per tu.",
      start: "Iniciar gravació",
      stop: "Aturar",
      processing: "Processant amb IA...",
      transcript: "Transcripció",
      preview: "Previsualització del document",
      use_text: "O escriu el text aquí",
      generate: "Generar",
      create_doc: "Crear document",
      example: 'Exemple: "Fes un pressupost per Restaurant Demo SL de 7.600 € més IVA per desenvolupament web i CRM"',
      no_mic: "El navegador no permet accés al micròfon",
    },
    settings: {
      title: "Configuració",
      company: "Empresa",
      account: "Compte",
      security: "Seguretat",
      companies: "Empreses",
      add_company: "Afegir empresa",
      logo: "Logotip (data URL)",
      iban: "IBAN",
      default_iva: "IVA per defecte",
      default_irpf: "IRPF per defecte",
      vat_mode_label: "Mode de preus per defecte",
      vat_mode_excluded: "Preus + IVA",
      vat_mode_included: "Preus amb IVA inclòs",
      vat_mode_hint: "Quan dictes per veu o introdueixes preus a l'editor, com es tracten per defecte. Pots sobreescriure-ho per cada document.",
      quote_prefix: "Prefix pressupost",
      invoice_prefix: "Prefix factura",
      twofa_enable: "Activar 2FA",
      twofa_disable: "Desactivar 2FA",
      twofa_scan: "Escaneja amb Google Authenticator / Authy i introdueix el codi",
      twofa_verify: "Verificar",
      saved: "Desat!",
      lang_user: "Idioma de la interfície",
    },
    status: {
      draft: "Esborrany",
      sent: "Enviat",
      accepted: "Acceptat",
      rejected: "Rebutjat",
      converted: "Convertit",
      pending: "Pendent",
      paid: "Cobrada",
      partial: "Parcial",
      overdue: "Impagada",
      cancelled: "Cancel·lada",
    },
    common: {
      loading: "Carregant...",
      error: "Error",
      success: "Èxit",
      yes: "Sí",
      no: "No",
      close: "Tancar",
    },
    pwa: {
      title: "Instal·la HO-SYS",
      subtitle: "Accés ràpid des de la pantalla d'inici",
      install: "Instal·lar",
    },
  },
  es: {
    app_name: "HOSYS INVOICE AI",
    nav: {
      dashboard: "Panel",
      clients: "Clientes",
      quotes: "Presupuestos",
      invoices: "Facturas",
      received: "Facturas recibidas",
      mailbox: "Buzón",
      products: "Mercancías",
      suppliers: "Proveedores",
      tax_books: "Libros fiscales",
      pricing: "Planes",
      security: "Seguridad",
      settings: "Ajustes",
      logout: "Cerrar sesión",
      activity: "Actividad",
    },
    landing: {
      tag: "Plataforma SaaS de facturación con IA por voz",
      headline: "Factura con la voz. Cobra con estilo.",
      sub: "Crea presupuestos y facturas profesionales dictándolos. Nuestra IA entiende catalán y castellano, redacta los conceptos y lo deja todo listo para firmar.",
      cta_primary: "Empieza gratis",
      cta_secondary: "Ver demo",
      feature_voice_title: "Agente IA de voz",
      feature_voice_desc: 'Di "Haz un presupuesto para Restaurant Demo SL de 7.600 € más IVA" y tendrás el documento creado.',
      feature_pdf_title: "PDFs A4 enterprise",
      feature_pdf_desc: "Logo corporativo, IBAN, QR de pago y tablas elegantes en cada documento.",
      feature_multi_title: "Multi-empresa",
      feature_multi_desc: "Gestiona varias empresas, equipos y numeraciones desde una sola cuenta.",
      feature_2fa_title: "Seguridad enterprise",
      feature_2fa_desc: "JWT, 2FA TOTP, logs de actividad, cifrado y protección anti-fuerza bruta.",
      stats: { docs: "documentos generados", uptime: "uptime", langs: "idiomas IA" },
      demo_label: "Demo",
      demo_quote_prefix: "Haz un presupuesto para",
      demo_quote_client: "Restaurant Demo SL",
      demo_quote_amount: "de 7.600 € más IVA por",
      demo_quote_suffix: "desarrollo web y plataforma CRM.",
      demo_lines: "3 líneas generadas",
      demo_iva: "IVA 21%",
      demo_json_desc_1: "Desarrollo sitio web corporativo",
      demo_json_desc_2: "Configuración CRM y Business Analytics",
      demo_json_desc_3: "Integración WebApp PWA y mobile-first",
      features_section_tag: "Características",
      features_section_title: "Todo lo que necesitas para facturar con estilo.",
      cta_section_badge: "Listo en 30 segundos",
      cta_section_title: "Empieza a facturar con voz, hoy.",
      cta_section_sub: "Sin tarjeta de crédito. Sin compromiso. Cancela cuando quieras.",
      cta_section_btn: "Crea tu cuenta gratis",
      footer_made: "Hecho con ❤ en Reus",
    },
    auth: {
      login: "Inicia sesión",
      register: "Crea tu cuenta",
      email: "Email",
      password: "Contraseña",
      full_name: "Nombre completo",
      company_name: "Nombre de la empresa",
      submit_login: "Entrar",
      submit_register: "Crear cuenta",
      no_account: "¿No tienes cuenta?",
      have_account: "¿Ya tienes cuenta?",
      totp_label: "Código 2FA (6 dígitos)",
      forgot_password: "¿Olvidaste la contraseña?",
      lang: "Idioma",
    },
    dashboard: {
      title: "Panel",
      welcome: "Buenos días",
      revenue_month: "Facturación del mes",
      pending: "Pendiente de cobrar",
      paid: "Cobrado",
      overdue: "Impagado",
      clients: "Clientes",
      invoices: "Facturas",
      quotes: "Presupuestos",
      monthly_revenue: "Evolución mensual",
      upcoming: "Vencimientos próximos",
      recent_activity: "Actividad reciente",
      no_data: "Aún no hay datos. ¡Crea el primer documento!",
      voice_cta: "Dictar un documento",
    },
    clients: {
      title: "Clientes",
      new: "Nuevo cliente",
      search: "Busca por nombre, NIF o email...",
      name: "Nombre",
      nif: "NIF/CIF",
      email: "Email",
      phone: "Teléfono",
      address: "Dirección",
      city: "Ciudad",
      postal_code: "C. Postal",
      country: "País",
      notes: "Notas internas",
      tags: "Etiquetas",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      empty: "Ningún cliente todavía. Empieza añadiendo el primero.",
      delete_confirm: "¿Seguro que quieres eliminar este cliente?",
      history: "Historial",
    },
    quotes: {
      title: "Presupuestos",
      new: "Nuevo presupuesto",
      number: "Núm.",
      client: "Cliente",
      date: "Fecha",
      total: "Total",
      status: "Estado",
      actions: "Acciones",
      duplicate: "Duplicar",
      convert: "Convertir a factura",
      pdf: "PDF",
      empty: "Ningún presupuesto todavía.",
      valid_until: "Válido hasta",
    },
    invoices: {
      title: "Facturas",
      new: "Nueva factura",
      number: "Núm.",
      client: "Cliente",
      date: "Fecha",
      due_date: "Vencimiento",
      total: "Total",
      status: "Estado",
      empty: "Ninguna factura todavía.",
      mark_paid: "Marcar como cobrada",
      record_payment: "Registrar pago",
      amount: "Importe",
      method: "Método",
      partial_paid: "Cobrado parcialmente",
    },
    editor: {
      new_quote: "Nuevo presupuesto",
      new_invoice: "Nueva factura",
      edit_quote: "Editar presupuesto",
      edit_invoice: "Editar factura",
      client: "Cliente",
      select_client: "Selecciona un cliente",
      add_item: "Añadir línea",
      description: "Descripción",
      quantity: "Cantidad",
      unit_price: "Precio unitario",
      vat: "IVA %",
      irpf: "IRPF %",
      discount: "Desc %",
      subtotal: "Subtotal",
      tax: "Impuestos",
      total: "Total",
      notes: "Notas",
      observations: "Observaciones",
      save: "Guardar",
      saving: "Guardando...",
      save_send: "Guardar y enviar",
      improve: "Mejorar con IA",
      delete: "Eliminar línea",
      back: "Volver",
      status: "Estado",
      due_date: "Vencimiento",
      date: "Fecha",
      kind: "Tipo",
    },
    voice: {
      title: "Agente IA de voz",
      sub: "Pulsa el botón y describe el documento. La IA creará el presupuesto o factura por ti.",
      start: "Iniciar grabación",
      stop: "Detener",
      processing: "Procesando con IA...",
      transcript: "Transcripción",
      preview: "Previsualización del documento",
      use_text: "O escribe el texto aquí",
      generate: "Generar",
      create_doc: "Crear documento",
      example: 'Ejemplo: "Haz un presupuesto para Restaurant Demo SL de 7.600 € más IVA por desarrollo web y CRM"',
      no_mic: "El navegador no permite acceso al micrófono",
    },
    settings: {
      title: "Ajustes",
      company: "Empresa",
      account: "Cuenta",
      security: "Seguridad",
      companies: "Empresas",
      add_company: "Añadir empresa",
      logo: "Logo (data URL)",
      iban: "IBAN",
      default_iva: "IVA por defecto",
      default_irpf: "IRPF por defecto",
      vat_mode_label: "Modo de precios por defecto",
      vat_mode_excluded: "Precios + IVA",
      vat_mode_included: "Precios con IVA incluido",
      vat_mode_hint: "Cuando dictas por voz o introduces precios en el editor, cómo se tratan por defecto. Puedes sobrescribirlo en cada documento.",
      quote_prefix: "Prefijo presupuesto",
      invoice_prefix: "Prefijo factura",
      twofa_enable: "Activar 2FA",
      twofa_disable: "Desactivar 2FA",
      twofa_scan: "Escanea con Google Authenticator / Authy e introduce el código",
      twofa_verify: "Verificar",
      saved: "¡Guardado!",
      lang_user: "Idioma de la interfaz",
    },
    status: {
      draft: "Borrador",
      sent: "Enviado",
      accepted: "Aceptado",
      rejected: "Rechazado",
      converted: "Convertido",
      pending: "Pendiente",
      paid: "Cobrada",
      partial: "Parcial",
      overdue: "Impagada",
      cancelled: "Cancelada",
    },
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      yes: "Sí",
      no: "No",
      close: "Cerrar",
    },
    pwa: {
      title: "Instala HO-SYS",
      subtitle: "Acceso rápido desde la pantalla de inicio",
      install: "Instalar",
    },
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("hosys_lang") || "ca");

  useEffect(() => {
    localStorage.setItem("hosys_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l);

  const t = (path, fallback = "") => {
    const parts = path.split(".");
    let cur = DICT[lang] || DICT.ca;
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else return fallback || path;
    }
    return cur;
  };

  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  return useContext(I18nCtx);
}
